(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[144],{

/***/ 20670:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online/product",
      function () {
        return __webpack_require__(91098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83844);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);






var Pagination = function(param) {
    var page = param.page, total = param.total, _size = param.size, size = _size === void 0 ? 4 : _size, url = param.url, _pagerCount = param.pagerCount, pagerCount = _pagerCount === void 0 ? 5 : _pagerCount;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var getUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(page) {
        if (!url) {
            var query = [
                "page=".concat(page)
            ];
            for(var key in router.query){
                if (key === "page") continue;
                var value = router.query[key];
                query.push("".concat(key, "=").concat(value));
            }
            return "".concat(router.pathname, "?").concat(query.join("&"));
        } else {
            return "".concat(url).concat(page);
        }
    }, [
        url,
        router.query
    ]);
    var lastPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Math.max(1, Math.ceil(total / size));
    }, [
        total,
        size
    ]);
    var pageList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var _list = [];
        var start = 1;
        var end = lastPage;
        if (lastPage > pagerCount + 2) {
            start = page > Math.ceil(pagerCount / 2) + 1 ? Math.max(1, page - Math.floor(pagerCount / 2)) : 1;
            end = page < lastPage - Math.ceil(pagerCount / 2) ? Math.min(lastPage, start + pagerCount - 1) : lastPage;
            if (end - start < pagerCount - 1) {
                start = end - pagerCount + 1;
            }
        }
        for(var i = start; i <= end; i++){
            _list.push(i);
        }
        return _list;
    }, [
        page,
        pagerCount,
        lastPage
    ]);
    var leftEllipsisVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[0] > 2;
    }, [
        pageList
    ]);
    var leftEllipsisPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[0] - 1;
    }, [
        pageList
    ]);
    var rightEllipsisVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[pageList.length - 1] < lastPage - 1;
    }, [
        pageList,
        lastPage
    ]);
    var rightEllipsisPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[pageList.length - 1] + 1;
    }, [
        pageList
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().pagination),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: page > 1 ? getUrl(page - 1) : "javascript:void(0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(page <= 1 ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().disabled) : ""),
                    children: "<"
                })
            }),
            leftEllipsisVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(1),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(leftEllipsisPage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: "\xb7\xb7\xb7"
                        })
                    })
                ]
            }),
            pageList.map(function(item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: item !== page ? getUrl(item) : "javascript:void(0)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(item === page ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active) : ""),
                        children: item
                    })
                }, item);
            }),
            rightEllipsisVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(rightEllipsisPage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: "\xb7\xb7\xb7"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(lastPage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: lastPage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: page < lastPage ? getUrl(page + 1) : "javascript:void(0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(page >= lastPage ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().disabled) : ""),
                    children: ">"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 91098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ProductList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85957);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28082);
/* harmony import */ var _components_seo_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90423);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34034);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81627);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25838);













var __N_SSP = true;
function ProductList(param) {
    var menuDetail = param.menuDetail, data = param.data;
    var ref, ref1, ref2;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_9__/* .useTranslations */ .T_)();
    console.log("数据", menuDetail, data, router);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        {
            id: "category",
            name: t("online.proCate")
        },
        {
            id: "name",
            name: t("online.proName")
        }
    ]), tabList = ref3[0], setTabList = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("category"), tabActice = ref4[0], setTabActice = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        category_ids: "",
        name: ""
    }), selected = ref5[0], setSelected = ref5[1];
    var getResult = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(query) {
        var _result = [];
        if (query === null || query === void 0 ? void 0 : query.category_ids) {
            var ref, ref1;
            (ref1 = query === null || query === void 0 ? void 0 : (ref = query.category_ids) === null || ref === void 0 ? void 0 : ref.split(",")) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(id) {
                var ref, ref1;
                _result.push({
                    id: Number(id),
                    type: "category",
                    label: (ref1 = menuDetail === null || menuDetail === void 0 ? void 0 : (ref = menuDetail.list) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                        return item.id == id;
                    })) === null || ref1 === void 0 ? void 0 : ref1["name_".concat(router.locale)]
                });
            });
        }
        if (query === null || query === void 0 ? void 0 : query.name) {
            _result.push({
                id: "99999",
                type: "name",
                label: query === null || query === void 0 ? void 0 : query.name
            });
        }
        return _result;
    }, [
        router,
        menuDetail
    ]);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), result = ref6[0], setResult = ref6[1];
    var getTreeData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(list) {
        return list === null || list === void 0 ? void 0 : list.map(function(item) {
            var ref;
            return {
                key: String(item === null || item === void 0 ? void 0 : item.id),
                value: item === null || item === void 0 ? void 0 : item.id,
                label: item === null || item === void 0 ? void 0 : item["name_".concat(router.locale)],
                children: (item === null || item === void 0 ? void 0 : (ref = item.childlist) === null || ref === void 0 ? void 0 : ref.length) ? getTreeData(item === null || item === void 0 ? void 0 : item.childlist) : []
            };
        });
    }, []);
    var gotoPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(query) {
        query = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, router.query, query);
        for(var key in query){
            if (!query[key]) {
                delete query[key];
            }
        }
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(query).toString()));
    }, [
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        setTabActice(((ref = router.query) === null || ref === void 0 ? void 0 : ref.tab) || "category");
        setSelected({
            category_ids: router.query.category_ids || "",
            name: router.query.name || ""
        });
        setResult(getResult(router.query));
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_3__/* .PageLayout */ .X, {
        temp: "page_crumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_8__/* .getHead */ .c)(menuDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().content), "m-1480"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().filter),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().tab),
                                    children: tabList === null || tabList === void 0 ? void 0 : tabList.map(function(item, index) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item), (item === null || item === void 0 ? void 0 : item.id) == tabActice && (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().active)),
                                            onClick: function() {
                                                if (item.id == tabActice) return;
                                                gotoPage({
                                                    category_ids: "",
                                                    name: "",
                                                    tab: item === null || item === void 0 ? void 0 : item.id,
                                                    page: 1
                                                });
                                            },
                                            children: item === null || item === void 0 ? void 0 : item.name
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().box),
                                    children: [
                                        tabActice == "category" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .TreeSelect */ .mP, {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().tree),
                                            filterTreeNode: true,
                                            multiple: true,
                                            placeholder: t("online.proCatePlace"),
                                            treeData: getTreeData(menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.list),
                                            value: (selected === null || selected === void 0 ? void 0 : selected.category_ids) ? (ref1 = selected === null || selected === void 0 ? void 0 : (ref = selected.category_ids) === null || ref === void 0 ? void 0 : ref.split(",")) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                                return Number(item);
                                            }) : [],
                                            onChange: function(value) {
                                                setSelected((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, selected), {
                                                    category_ids: value === null || value === void 0 ? void 0 : value.join(",")
                                                }));
                                            }
                                        }),
                                        tabActice == "name" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .II, {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().input),
                                            value: selected === null || selected === void 0 ? void 0 : selected.name,
                                            placeholder: t("online.proNamePlace"),
                                            onChange: function(value) {
                                                setSelected((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, selected), {
                                                    name: value
                                                }));
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().search),
                                            onClick: function() {
                                                gotoPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, selected), {
                                                    tab: tabActice,
                                                    page: 1
                                                }));
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().result),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().label),
                                            children: t("online.result")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().arr),
                                            children: result === null || result === void 0 ? void 0 : result.map(function(item, index) {
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item),
                                                    onClick: function() {
                                                        var _query = null;
                                                        if ((item === null || item === void 0 ? void 0 : item.type) == "category") {
                                                            var ref, ref1;
                                                            _query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, selected), {
                                                                category_ids: (ref1 = (ref = result === null || result === void 0 ? void 0 : result.filter(function(itm) {
                                                                    return (itm === null || itm === void 0 ? void 0 : itm.id) != (item === null || item === void 0 ? void 0 : item.id);
                                                                })) === null || ref === void 0 ? void 0 : ref.map(function(itm) {
                                                                    return itm === null || itm === void 0 ? void 0 : itm.id;
                                                                })) === null || ref1 === void 0 ? void 0 : ref1.join(",")
                                                            });
                                                        } else {
                                                            _query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, selected), {
                                                                name: ""
                                                            });
                                                        }
                                                        gotoPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, _query), {
                                                            tab: tabActice,
                                                            page: 1
                                                        }));
                                                    },
                                                    children: item === null || item === void 0 ? void 0 : item.label
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reset),
                                            onClick: function() {
                                                gotoPage({
                                                    category_ids: "",
                                                    name: "",
                                                    tab: tabActice,
                                                    page: 1
                                                });
                                            },
                                            children: t("online.reset")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().list),
                            children: data === null || data === void 0 ? void 0 : (ref2 = data.list) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, index) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        href: "/online/product/info?id=".concat(item === null || item === void 0 ? void 0 : item.id),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cover),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: item === null || item === void 0 ? void 0 : item.image,
                                                        alt: item === null || item === void 0 ? void 0 : item.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().info),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().name),
                                                            children: item === null || item === void 0 ? void 0 : item.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().company),
                                                            children: item === null || item === void 0 ? void 0 : item.company
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().other),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().venues),
                                                                    children: [
                                                                        t("online.booth"),
                                                                        item === null || item === void 0 ? void 0 : item.booth_num
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cate),
                                                                    children: item === null || item === void 0 ? void 0 : item.category_name
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                !!item.is_new && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["new"]),
                                                    src: "http://admin.ipbexpo.com/uploads/editor/20250522/1d768871001222bd21322e845a7f2855.png",
                                                    alt: ""
                                                })
                                            ]
                                        })
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pagination),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_pagination__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                page: Number(router.query.page || 1),
                                total: data === null || data === void 0 ? void 0 : data.total,
                                size: data === null || data === void 0 ? void 0 : data.per_page
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/getHomeMenuDetail", {
                            params: {
                                path: context === null || context === void 0 ? void 0 : (ref = context.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")[0]
                            },
                            headers: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: data.data || null,
                                menuDetail: data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title,
                    " "
                ]
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 83844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"seo-pagination_m-1480__HQLDo","pagination":"seo-pagination_pagination__VyFuW","active":"seo-pagination_active__QulN_","disabled":"seo-pagination_disabled__DdGW1"};

/***/ }),

/***/ 34034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"styles_m-1480__BZbB0","container":"styles_container__6tflj","content":"styles_content__uNfD7","filter":"styles_filter__3BDn8","tab":"styles_tab__K7SH9","item":"styles_item__rpfGj","active":"styles_active__BiRlA","box":"styles_box__gDHi0","tree":"styles_tree__5fcAF","input":"styles_input__Hs62a","search":"styles_search__e__J_","result":"styles_result__1DsYC","label":"styles_label__Lt5C5","arr":"styles_arr__PycwS","reset":"styles_reset__ZYdkh","list":"styles_list__WM2wT","cover":"styles_cover__9OAds","info":"styles_info__mNL4a","other":"styles_other__Q5DJh","name":"styles_name__Tt0Cg","company":"styles_company__2Ln6B","venues":"styles_venues__whwpE","cate":"styles_cate__B8XKX","new":"styles_new__BVlRQ","pagination":"styles_pagination__td_Lg"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,912,774,888,179], function() { return __webpack_exec__(20670); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);